import { Box, Button, Typography } from "@mui/material";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import Download from "@mui/icons-material/Download";

interface UnsupportedPreviewProps {
  fileUrl: string;
  fileExtension: string;
}

export function UnsupportedPreview({
  fileUrl,
  fileExtension,
}: UnsupportedPreviewProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
      }}
    >
      <InsertDriveFileOutlined
        sx={{ fontSize: 64, color: "text.secondary" }}
      />
      <Typography variant="body1" color="text.secondary">
        Preview is not available for .{fileExtension} files.
      </Typography>
      <Button
        variant="outlined"
        href={fileUrl}
        download
        startIcon={<Download />}
      >
        Download to view
      </Button>
    </Box>
  );
}
